<template>
  <el-upload 
    ref="upload" 
    class="upload-demo" 
    :action="action_url" 
    :on-preview="handlePreview"
    :before-remove="beforeRemove" 
    :on-exceed="handleExceed" 
    :on-change="change" 
    :limit="limit" 
    :file-list="fileList"
    :accept="accept" 
    :auto-upload="false" 
    :headers="headers" 
    :data="params" 
    :disabled="disabled" 
    :on-error="error"
    :on-success="success" 
    name="file"
  >
    <el-button v-if="!disabled" size="small" type="primary">点击上传</el-button>
  </el-upload>
</template>

<script>
export default {
  props: {
    fileList: {
      typeof: Array,
      default() {
        return [];
      },
    },
    accept: {
      typeof: String,
      default() {
        return "";
      },
    },
    limit: {
      typeof: Number,
      default() {
        return 100;
      },
    },
    action: {
      typeof: String,
      default() {
        return `/test`;
      },
    },
    params: {
      typeof: String,
      default() {
        return {};
      },
    },
    disabled: {
      typeof: Boolean,
      default() {
        return false;
      },
    },
    canDown: {
      typeof: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      headers: {
          Authcollector: "Bearer " + this.$store.state.token,
      },
      isSuccess: true,
    };
  },
  methods: {
    handlePreview(file) {
      if (!this.canDown) {
        this.$message.warning("无下载权限，请联系管理员");
        return;
      }
      const a = document.createElement("a");
      a.href = this.getVueBaseApi() + `/system/clientversioninfo/downloadFile?zipPath=${file.path}`;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    change(file, fileList, scope) {
      const fileName = file.name;
      const fileType = fileName.substr(fileName.lastIndexOf(".") + 1).toLowerCase();
      if (this.accept && !this.accept.includes(fileType)) {
        fileList.splice(fileList.length - 1, 1);
        this.$message.warning(`请选择${this.accept}文件格式`);
        return;
      }
      const size = Number(file.size / 1024 / 1024)
      if (size > 100) {
        this.$message.warning('无法上传超过100MB的文件，请联系管理员')
        fileList.splice(fileList.length - 1, 1);
        return;
      }
    },
    error(err) {
      console.log(err)
    },
    success(res, file, fileList) {
      if (res.code != 200) {
        this.$message.error(res.msg);
        this.isSuccess = false;
      }
      if (file.name == fileList[fileList.length - 1].name) {
        if (this.isSuccess) {
          this.$emit("success", fileList.length);
        }
        this.isSuccess = true;
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择${this.limit}个文件，已经达到阈值`);
    },
  },
  computed: {
    action_url() {
      return this.getVueBaseApi() + `${this.action}`;
    },
  },
  created() {
    this.isSuccess = true;
  },
};
</script>

<style lang="sass" scoped></style>
